let windowWidth;
let page;
const MAX_WINDOW_WIDTH_XS = 823;

export default {
  windowWidth,
  page,
  MAX_WINDOW_WIDTH_XS,
};



// WEBPACK FOOTER //
// ./src/js/consts.js